import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const VendorPayListApi = createSlice({
  name: "VendorPayListApi",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_vendor_pay: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_vendor_pay: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
    },
    failure_api_call_vendor_pay: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    vendor_isFirst: (state, action) => {
      state.isFirst = false;
    },
  },
});
export default VendorPayListApi.reducer;
export const {
  list_vendor_pay,
  success_api_call_vendor_pay,
  failure_api_call_vendor_pay,
  vendor_isFirst,
} = VendorPayListApi.actions;
